import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#2c3e50",
    color: "#fff",
    fontSize: 12,
    fontWeight: 500,
    padding: "6px 10px",
    borderRadius: "6px",
    boxShadow: theme.shadows[4],
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#2c3e50",
  },
}));


export const UnitStatusBadge = ({ status }) => {
  switch (status) {
    case "IN_STOCK":
      return (
        <span className="badge bg-success-subtle text-success">IN STOCK</span>
      );
    case "ALLOCATED":
      return (
        <span className="badge bg-primary-subtle text-primary">
          ALLOCATED
        </span>
      );
    case "IN_REPAIR":
      return (
        <span className="badge bg-warning-subtle text-warning">
          IN REPAIR
        </span>
      );
    default:
      return (
        <span className="badge bg-danger-subtle text-danger">DISPOSED</span>
      );
  }
};

